// Generate consistent color based on subteam ID or name
export const getSubteamColor = (subteamId, subteamName) => {
    const identifier = `${subteamId || ''}::${subteamName || ''}` || 'default';

    // Generate a hash from the identifier
    let hash = 0;
    for (let i = 0; i < identifier.length; i++) {
        hash = identifier.charCodeAt(i) + ((hash << 5) - hash);
    }

    // Spread values across hue, saturation, and lightness to reduce collisions
    const hue = Math.abs(hash) % 360;
    const saturation = 55 + (Math.abs(hash) % 20); // 55-74%
    const lightness = 80 + (Math.abs(hash) % 10); // 80-89%

    return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
};

// Generate initials for subteam name
// If two words, show first letter of each word
// If one word, show first letter
export const getSubteamInitials = (subteamName) => {
    if (!subteamName) return 'S';
    
    const words = subteamName.trim().split(/[\s_-]+/);
    if (words.length >= 2) {
        // Two or more words: first letter of first two words
        return (words[0].charAt(0) + words[1].charAt(0)).toUpperCase();
    }
    // Single word: first letter
    return words[0].charAt(0).toUpperCase();
};

// Generate initials with duplicate handling (S1, S2, etc.)
// This is useful when displaying multiple subteams together
export const getSubteamInitialsWithDuplicates = (subteams) => {
    if (!subteams || subteams.length === 0) return [];

    // First, generate base initials for all subteams
    const subteamsWithBaseInitials = subteams.map(subteam => ({
        ...subteam,
        baseInitials: getSubteamInitials(subteam.name || subteam)
    }));

    // Count occurrences of each base initial
    const initialsCount = {};
    subteamsWithBaseInitials.forEach(subteam => {
        const key = subteam.baseInitials;
        initialsCount[key] = (initialsCount[key] || 0) + 1;
    });

    // Generate final initials with numbers for duplicates
    return subteamsWithBaseInitials.map((subteam) => {
        const baseInitials = subteam.baseInitials;
        
        // If this initial appears more than once, add a number
        if (initialsCount[baseInitials] > 1) {
            // Find the position of this subteam among subteams with the same initial
            const sameInitialSubteams = subteamsWithBaseInitials.filter(
                s => s.baseInitials === baseInitials
            );
            const position = sameInitialSubteams.findIndex(s => {
                const id1 = s._id || s.id || s;
                const id2 = subteam._id || subteam.id || subteam;
                return String(id1) === String(id2);
            }) + 1;
            return {
                ...subteam,
                displayInitials: `${baseInitials}${position}`
            };
        } else {
            return {
                ...subteam,
                displayInitials: baseInitials
            };
        }
    });
};
